import React from 'react'

function ScreenLoader({loadingContent, loaded}) {

  const style ={
    width: '100%',
    height: '100vh',
    top: '0',
    background: 'rgba(255,255,255,.95)',
    left: '0',
    position: 'fixed',
    zIndex: '100'
  }

  return (
    <div className="screen-loader" style={style}>
      <div className="empty-event h-100">
        <div className="empty-event-content bg-transparent h-100 flex-column">
          
          <div className="spinner-grow text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <div className="loadingContent">
            <p style={{fontSize: '20px'}}>{loadingContent}</p>
          </div>          
        </div>
      </div>
    </div>
  )
}

export default ScreenLoader
